module.exports = __webpack_public_path__ + "static/learning-app-cover-1a946ce31153e501f1bad06116867d6b.png";